// Sale dates/times are stored as the track's wall clock (a date column and a
// time string) and are always DISPLAYED verbatim — never converted to the
// viewer's zone. The track's IANA timezone exists purely to label the values.

// Generic abbreviation for an IANA zone ("America/Chicago" -> "CT").
// Falls back to the DST-specific form ("CDT"), then to nothing.
const cache = {};

export const zoneAbbr = (timeZone) => {
  if (!timeZone) return null;
  if (timeZone in cache) return cache[timeZone];
  let abbr = null;
  for (const style of ['shortGeneric', 'short']) {
    try {
      const part = new Intl.DateTimeFormat('en-US', {
        timeZone,
        timeZoneName: style,
      })
        .formatToParts(new Date())
        .find((p) => p.type === 'timeZoneName');
      if (part && part.value) {
        abbr = part.value;
        break;
      }
    } catch (e) {
      // Unsupported style or bad zone id — try the next form.
    }
  }
  cache[timeZone] = abbr;
  return abbr;
};
